<template>
    <SrAppLink class="sr-link-list-item" :class="{ disabled: isDisabled }" :disabled="isDisabled" :to="href">
        <VCard>
            <v-list-item three-line>
                <v-list-item-avatar tile size="6.6rem">
                    <SrIcon :icon="iconName" size="xl" active />
                </v-list-item-avatar>
                <v-list-item-content>
                    <v-list-item-title>
                        <SrHeadline>
                            {{ title }}
                        </SrHeadline>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        <SrHeadline color="dark-gray" level="3">
                            {{ description }}
                        </SrHeadline>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <SrHeadline class="disabled-notice" color="gray-border--text" level="3">
                    {{ disabledNotice }}
                </SrHeadline>
            </v-list-item>
        </VCard>
    </SrAppLink>
</template>

<script>
import { SrHeadline } from '../SrHeadline';
import { SrIcon } from '../SrIcon';

import SrAppLink from './SrAppLink';

export default {
    name: 'SrLinkListItem',
    components: { SrHeadline, SrIcon, SrAppLink },
    props: {
        iconName: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        disabledNotice: {
            type: String,
            default: 'Available soon',
        },
        href: {
            type: String,
            // eslint-disable-next-line no-script-url
            default: 'javascript:',
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
